import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookmarkFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M20 20.2051C19.9999 20.5193 19.9169 20.8283 19.7591 21.1006C19.6012 21.3729 19.3734 21.5999 19.0998 21.7576C18.8263 21.9152 18.5158 21.9989 18.1996 22C17.8833 22.001 17.572 21.9195 17.2974 21.7636L12.6401 19.1194C12.4452 19.0088 12.2245 18.9501 12 18.9501C11.7755 18.9501 11.5548 19.0088 11.3599 19.1194L6.70262 21.7636C6.42795 21.9195 6.11672 22.001 5.8004 22C5.48421 21.9989 5.17372 21.9152 4.9002 21.7576C4.62658 21.5999 4.39885 21.3729 4.24093 21.1006C4.12256 20.8963 4.04593 20.6716 4.01512 20.4395L4 20.2051V4.82051C4 4.07247 4.29929 3.35527 4.83165 2.82632C5.36401 2.29737 6.08584 2 6.83871 2H17.1613C17.9142 2 18.636 2.29737 19.1683 2.82632C19.7007 3.35527 20 4.07247 20 4.82051V20.2051Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgBookmarkFilled);
export { ForwardRef as ReactComponent };
